import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';
import logo from '../../assets/mino_logo.png';
import { showToast } from '../../utils/toast';

const Footer = () => {
  const { t } = useTranslation();
  const contractAddress = "0x0000000000000000000000000000000000000000";

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(contractAddress);
      showToast.success(t('footer.copySuccess'));
    } catch (err) {
      showToast.error(t('footer.copyError'));
      console.error('Failed to copy:', err);
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerLogoContainer}>
            <img src={logo} alt="Mino Logo" className={styles.footerLogo} />
            <h2 className={styles.footerTitle}>MINO</h2>
        </div>
        
        <div className={styles.footerLinks}>
          <a 
            className={styles.footerLink}
          >
            {t('footer.buy')}
          </a>
          
          <a 
            href="https://x.com/TetrisBNB"
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            {t('footer.twitter')}
          </a>
          
          <a 
            href="https://t.me/TetrisBNB"
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            {t('footer.telegram')}
          </a>
          
          <a 
            href="https://dexscreener.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            {t('footer.dexscreener')}
          </a>
        </div>
        
        <div className={styles.footerContact}>
          <a 
            href="mailto:support@tetrisbnb.fun"
            className={styles.footerContactLink}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000">
              <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280 320-200v-80L480-520 160-720v80l320 200Z"/>
            </svg>
            <span>support@tetrisbnb.fun</span>
          </a>
        </div>
      </div>
      <div className={styles.footerContract} onClick={handleCopyAddress}>
        <span>{t('footer.contractAddress')}{contractAddress}</span>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          height="24px" 
          viewBox="0 -960 960 960" 
          width="24px" 
          fill="#000000" 
          className={styles.copyIcon}
        >
          <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Z"/>
        </svg>
      </div>
    </footer>
  );
};

export default Footer;
